import { render, staticRenderFns } from "./CompanyMobileTakenCompany.vue?vue&type=template&id=67978692"
import script from "./CompanyMobileTakenCompany.vue?vue&type=script&lang=js"
export * from "./CompanyMobileTakenCompany.vue?vue&type=script&lang=js"
import style0 from "./CompanyMobileTakenCompany.vue?vue&type=style&index=0&id=67978692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports